export interface NumberLinePlacementObject {
  t: string;
  [key: string]: unknown;
}

/**
 * Returns number-line objects after adding a ray or segment.
 * One-mark modes retain one object; two-mark mode retains a segment or the two newest rays.
 */
export const getNumberLineObjectsAfterAdd = <
  T extends NumberLinePlacementObject
>(
  objects: T[] | undefined,
  object: T,
  mode: string | undefined
): T[] => {
  if (object.t === 'Segment' || mode !== '2') {
    return [object];
  }

  const nextObjects = objects || [];

  if (nextObjects.length > 1) {
    nextObjects.splice(0, 1);
  }

  nextObjects.push(object);

  return nextObjects;
};
